<template>
  <div class="goal" :class="{ 'goal--active': active, 'goal--sending': sending }">
    <div class="item__overlay"
         :class="{ 'item__overlay--show-bid': purchasePlaced && active }">
      <div class="item__overlay-text">
        <i class="icon-star-david"></i>
        <h3 class="thankyou">{{ this.payment.pay.selected === 'pledge' ? $t('thank-you-for-pledge') : $t('thank-you-for-purchasing') }}</h3>
        <h4 class="title">{{data.title}}</h4>
        <h4 class="title">{{data.translation}}</h4>
        <span class="for">for</span>
        <h2 class="bid">${{this.amount.value}}</h2>
        <p>
          {{ $t('order-confirmation-sent') }}
        </p>
        <span class="close" @click="close">{{ $t('close') }}</span>
      </div>
    </div>
    <span class="goal__close icon-close" @click="close"></span>
    <div class="goal__info">
      <div class="goal__info-block">
        <h4 class="title">{{data.name}}</h4>
        <h4 class="title">{{data.hebrew_name}}</h4>
      </div>
      <div class="goal__info-block" v-if="data.date !== null">
        <span class="label">{{ $t('time-left') }}</span>
        <span class="time">{{data.date}}</span>
      </div>
    </div>
    <div class="goal_description">
      <p>{{data.description}}</p>
    </div>
    <GoalProgress :percent="data.percent_funded" :progress="data.amount_funded_cents" :target="data.communal_goal_amount_cents" v-if="data.communal_goal_amount_cents > 0" />
    <div class="goal__content" :class="{ 'goal__content--active': active }">

      <div class="form-field">
        <div class="form-control form-goal-container">
          <Input :data="amount" bid choose-enter :choose-options="data.preset_amounts" :min-amount="minAmount" :show-min-amount="showMinAmount" />
        </div>
      </div>

      <PurchaseForm :id="data.id" :pledge="data.is_accepting_pledges" :echeck="data.is_accepting_echeck" :card="data.is_accepting_card" payment goal :goal-valid="amount.valid"  />
    </div>
    <button class="btn btn--tertiary" :class="{ 'btn--fade': active }" @click="showGoal(index)">
      {{ $t('give-now') }}
    </button>
    <div class="align-center mt-1">
      <span v-if="!cause.is_donor_list_hidden" class="goal__contributors" @click="showDonors(data.id)">Contributors</span>
      <pulse-loader color="#A19378" :loading="sending" />
    </div>
  </div>
</template>

<script>
  import Input from '../inputs/Input';
  import GoalProgress from './GoalProgress';
  import PurchaseForm from '../forms/PurchaseForm';
  import { EventBus } from '../../eventbus';
  import { mapState } from 'vuex';
  import { log } from "../../utilities/log";
  import axios from "axios";
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
  import modalHelper from '../../mixins/modalHelper';

  export default {
    name: 'Goal',

    components: {
      GoalProgress,
      Input,
      PurchaseForm,
      PulseLoader
    },

    mixins: [
      modalHelper
    ],

    props: {
      active: Boolean,
      data: Object,
      index: String
    },

    data: () => {
      return {
        orderValue: null,
        purchasePlaced: false,
        sending: false
      }
    },

    watch: {
      active: function(oldVal, newVal) {
        if(newVal !== oldVal) {
          this.purchasePlaced = false;
          this.sending = false;
          EventBus.$emit('clear-errors');
        }
      }
    },

    computed: {
      ...mapState({
        causes: state => state.causes,
        payment: state => state.purchaseForm,
        subdomain: state => state.subdomain,
        amount: state => state.purchaseForm.amount
      }),
      cause: function () {
        return this.causes.filter((cause) => cause.id === this.$route.params.cause_id)[0];
      },
      showMinAmount: function() {
        return this.data.minimum_amount_cents > 100 && this.amount.value === '';
      },
      minAmount: function() {
        return this.data.minimum_amount_cents/100;
      }
    },

    mounted: function () {
      EventBus.$on('purchase-goal', this.purchaseGoal);
    },
    beforeDestroy: function () {
      EventBus.$off('purchase-goal', this.purchaseGoal);
    },

    methods: {
      showDonors: async function(id) {
        try {
          await this.$store.dispatch('updateRecentDonations', { id: id });
          this.toggleModal('goalContributors');
        } catch(err) {
          log(`Error Opening Recent Donors Modal : ${err.message}`, 'error');
        }
      },
      showGoal: async function(i) {
        try {
          EventBus.$emit('active-goal', i);
          await this.$store.dispatch('updateClearAmountInput');
        } catch(err) {
          log(`Error Clearing Goal Input/Opening Item: ${err.message}`, 'error');
        }
      },
      close: function () {
        EventBus.$emit('active-goal', null);
        this.purchasePlaced = false;
      },
      purchaseGoal: async function(id) {
        if (id === this.data.id) {
          try {
            this.sending = true;
            this.orderValue = this.data.price;

            let paymentInfo = {
              type: 'payment-profiles',
              is_charging_allowed: true
            };

            switch(this.payment.pay.selected) {
              case 'card':
                paymentInfo = {
                  ...paymentInfo,
                  is_echeck: false,
                  first_name: this.payment.cardName.value.split(' ')[0],
                  last_name: this.payment.cardName.value.split(' ')[1],
                  email: this.payment.purchaseEmail.value,
                  number: this.payment.cardNumber.value.replace(/-/g, ''),
                  expiration: this.payment.exp.value,
                  verification_value: this.payment.cvv.value,
                  zipcode: this.payment.zip.value,
                };
                break;
              case 'echeck':
                paymentInfo = {
                  ...paymentInfo,
                  is_echeck: true,
                  account_name: this.payment.accountName.value,
                  account_number: this.payment.accountNumber1.value,
                  account_number_confirmation: this.payment.accountNumber2.value,
                  routing_number: this.payment.routingNumber.value
                };
                break;
            }

            let name = null;

            switch (this.payment.pay.selected) {
              case 'card':
                name = this.payment.cardName.value;
                break;
              case 'echeck':
                name = this.payment.accountName.value;
                break;
              case 'pledge':
                name = this.payment.purchaseName.value;
                break;
            }

            let submissionData = {
              source: this.payment.pay.selected,
              donor_email: this.payment.purchaseEmail.value,
              donor_first_name: name.split(' ')[0],
              donor_last_name: name.split(' ')[1],
              donation_plan_id: this.data.id,
              cause_id: this.data.cause_id,
              amount_cents: parseFloat(this.amount.value.replace(/,/g, '')) * 100
            };

            if(this.payment.pay.selected === 'card' || this.payment.pay.selected === 'echeck') {
              submissionData = {
                ...submissionData,
                included: [{ ...paymentInfo }]
              }
            }

            let resp = null;

            if(!this.payment.installments.options[0].checked) {
              log('Purchase Goal Submission Data:', 'debug');
              console.table(submissionData);

              resp = await axios.post(`https://${this.subdomain}.${process.env.VUE_APP_API_BASE_URL}/donation_plans/${this.data.id}/donations`, submissionData, {
                headers: {
                  'X-JC-Source': 'raisesouls'
                }
              });
            } else {
              const installmentsCount = this.payment.installments.options[0].input.selected;
              const beginDate = new Date(new Date(new Date().setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString();

              submissionData = {
                ...submissionData,
                amount_cents: this.data.amount_cents/installmentsCount*100,
                repeat_interval: 'monthly',
                max_repeat_count: installmentsCount,
                starts_at: beginDate,
                next_charge_at: beginDate
              };

              log('Purchase Goal Submission Data:', 'debug');
              console.table(submissionData);

              resp = await axios.post(`https://${this.subdomain}.${process.env.VUE_APP_API_BASE_URL}/donation_plans/${this.data.id}/recurring_donations`, submissionData,{
                headers: {
                  'X-JC-Source': 'raisesouls'
                }
              });
            }

            log('Purchase Goal Response:', 'debug');
            console.log(resp);

            this.purchasePlaced = resp.status === 201;
            this.sending = false;
          } catch (err) {
            this.sending = false;
            const msg = err.response ? err.response.data.errors[0].detail : err.message;
            EventBus.$emit('error', msg);
            log(`Error Placing Purchase Goal ${id}: ${err.message}`, 'error');
            console.table(err.response.data.errors);
          }
        }
      }
    }
  }
</script>
